import { render, staticRenderFns } from "./DisplayPSF.vue?vue&type=template&id=0673b592"
import script from "./DisplayPSF.vue?vue&type=script&lang=js"
export * from "./DisplayPSF.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports